import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'arrow-to-right-icon',
  templateUrl: './arrow-to-right-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArrowToRightIconComponent {}
